import React from 'react';
import './App.css';
import QuickQuoteWidget from './components/QuickQuoteWidget';

const App = ({ disclaimerText, headingText, submitButtonText, costAltText, jewelryTypes, qqLink, qqDesktopMode }) => {
  return (
    <div className="App">
      <QuickQuoteWidget
        disclaimerText={disclaimerText}
        headingText={headingText}
        submitButtonText={submitButtonText}
        costAltText={costAltText}
        jewelryTypes={jewelryTypes}
        qqLink={qqLink}
        qqDesktopMode={qqDesktopMode}
      />
    </div>
  );
};

export default App;